import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

import { UtilityService } from '../services/utility.service';
import { localizeRoutes, registerRouteTranslator } from './localize-routes';
import { RouteTranslatorService } from './route-translator.service';

/**
 * Loads the active locale, translates the root route config, and releases the initial
 * navigation.
 *
 * The router is configured with `initialNavigation: 'disabled'` so that no navigation
 * happens until route paths have been translated — otherwise the first navigation would
 * resolve against untranslated keys (`/Misc_tutor_search` rather than `/docenten`).
 *
 * Must be registered before any other APP_INITIALIZER that can trigger a navigation.
 */
export async function initializeLocalizedRoutes(): Promise<void> {
  const translate = inject(TranslateService);
  const utility = inject(UtilityService);
  const translator = inject(RouteTranslatorService);
  const router = inject(Router);

  // One locale per domain: 'nl' for bijlesaanhuis.nl, 'de' for lernigo.de.
  const language = utility.country;

  translate.setDefaultLang(language);
  const translations = await firstValueFrom(translate.use(language));

  translator.setTranslations(translations);
  // Registered before translating so lazily-loaded child configs can call localizeRoutes().
  registerRouteTranslator(translator);

  router.resetConfig(localizeRoutes(router.config));
  router.initialNavigation();
}
